import dayjs from '~libs/dayjs';

import { Step } from '~components/wizard-form/props';

import { selectLookupUsers } from '~care-workers/selectors/users';
import { selectLookupSahQuarterlyClientPackages } from '~main/selectors/clients/clientPackages';

import Execute from '~support-at-home/components/level-move/Execute';
import Preview from '~support-at-home/components/level-move/Preview';

const validateChangeoverDate = (values: any): boolean => {
  const { changeover_date, _locked_date, _end_date } = values;
  if (!changeover_date) return false;
  if (_locked_date && dayjs(changeover_date).isBefore(dayjs(_locked_date), 'day')) return false;
  if (_end_date && dayjs(changeover_date).isAfter(dayjs(_end_date), 'day')) return false;
  return true;
};

const deriveChangeoverDateWarning = (values: any): string => {
  const { changeover_date, _locked_date, _end_date } = values;
  if (!changeover_date) return '';
  if (_locked_date && dayjs(changeover_date).isBefore(dayjs(_locked_date), 'day')) {
    return 'Changeover date must be on or after the locked date';
  }
  if (_end_date && dayjs(changeover_date).isAfter(dayjs(_end_date), 'day')) {
    return 'Changeover date must be on or before the schedule end date';
  }
  return '';
};

const steps: Step[] = [
  {
    step: 1,
    title: 'Schedule & Package',
    fields: {
      client_name: {
        type: 'readonly',
        field: 'client_name',
        caption: 'Client',
        isAttribute: false,
      },
      current_package_name: {
        type: 'readonly',
        field: 'current_package_name',
        caption: 'Current Package',
        isAttribute: false,
      },
      schedule_start_date: {
        type: 'readonly',
        field: 'schedule_start_date',
        caption: 'Schedule Start',
        isAttribute: false,
      },
      schedule_end_date: {
        type: 'readonly',
        field: 'schedule_end_date',
        caption: 'Schedule End',
        isAttribute: false,
      },
      schedule_locked_date: {
        type: 'readonly',
        field: 'schedule_locked_date',
        caption: 'Locked Date',
        isAttribute: false,
      },
      schedule_balance: {
        type: 'readonly',
        field: 'schedule_balance',
        caption: 'Balance',
        className: 'border-bottom pb-3 mb-2',
        isAttribute: false,
      },
      new_package_id: {
        type: 'select',
        field: 'new_package_id',
        caption: 'New Package',
        required: true,
        placeholder: '-- Select a package --',
        selectorOptions: selectLookupSahQuarterlyClientPackages,
        isAttribute: false,
      },
      changeover_date: {
        type: 'date',
        field: 'changeover_date',
        caption: 'Changeover Date',
        required: true,
        validate: validateChangeoverDate,
        deriveWarning: deriveChangeoverDateWarning,
        isAttribute: false,
      },
      case_manager_id: {
        type: 'select',
        field: 'case_manager_id',
        caption: 'Case Manager',
        required: true,
        placeholder: '-- Select a case manager --',
        selectorOptions: selectLookupUsers,

        isAttribute: false,
      },
      _locked_date: {
        type: 'hidden',
        field: '_locked_date',
        isAttribute: false,
      },
      _end_date: {
        type: 'hidden',
        field: '_end_date',
        isAttribute: false,
      },
    },
  },
  {
    step: 2,
    title: 'Preview Appointments',
    nextButtonCaption: 'Confirm',
    fields: {
      step2: {
        type: 'custom',
        component: Preview,
        colSize: 12,
        dependencies: ['changeover_date'],
      },
    },
  },
  {
    step: 3,
    title: 'Execute Level Move',
    showPrevButton: false,
    showNextButton: false,
    fields: {
      step3: {
        type: 'custom',
        component: Execute,
        colSize: 12,
        dependencies: [
          'new_package_id',
          'changeover_date',
          'case_manager_id',
          'repeat_appointment_ids',
          'fixed_appointment_ids',
        ],
      },
    },
  },
];

export default steps;
